export let XIDItemType;

(function (XIDItemType) {
  XIDItemType["XC"] = "xc";
  XIDItemType["UID"] = "uid";
})(XIDItemType || (XIDItemType = {}));

export let XIDState;

(function (XIDState) {
  XIDState["NEW"] = "NEW";
  XIDState["CHANGED"] = "CHANGED";
  XIDState["EXISTING"] = "EXISTING";
  XIDState["TIMEOUT"] = "TIMEOUT";
  XIDState["ERROR"] = "ERROR";
  XIDState["UNAVAILABLE"] = "UNAVAILABLE";
  XIDState["MALFORMED"] = "MALFORMED";
  XIDState["UNKNOWN"] = "UNKNOWN";
})(XIDState || (XIDState = {}));